/** One SRF's allocation grid (user, 2026-10-14). */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { AllocationGridPage } from "@/features/quality/components/allocation/allocation-grid-page";

export const Route = createFileRoute("/_app/quality/allocation/$srfId")({
  params: {
    parse: ({ srfId }) => {
      if (!/^\d+$/.test(srfId)) throw notFound();
      return { srfId };
    },
    stringify: (p) => p,
  },
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.allocate")) throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { srfId } = Route.useParams();
  return <AllocationGridPage key={srfId} srfId={Number(srfId)} />;
}
